import { render, staticRenderFns } from "./P2POffersFilters.vue?vue&type=template&id=66bc7357&"
import script from "./P2POffersFilters.vue?vue&type=script&lang=js&"
export * from "./P2POffersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports